export const columns = [
  {
    title: '排序',
    dataIndex: 'list_order',
    scopedSlots: { customRender: 'list_order' },
    width: 100,
  },
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '标题',
    dataIndex: 'name',
  },
  {
    title: '作者',
    dataIndex: 'admin_name',
  },
  {
    title: '点击量',
    dataIndex: 'hits',
  },
  {
    title: '点赞',
    dataIndex: 'likes',
  },
  {
    title: '收藏',
    dataIndex: 'favorites',
  },
  {
    title: '缩略图',
    dataIndex: 'thumbnail',
    scopedSlots: { customRender: 'thumbnail' },
    width: 100,
  },
  {
    title: '更新时间',
    dataIndex: 'update_time',
  },
  {
    title: '发布时间',
    dataIndex: 'create_time',
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

export const formData = [
  {
    name: 'company_id',
    lable: '选择企业',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'group_id',
    lable: '选择栏目',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'name',
    lable: '标题',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'post_excerpt',
    lable: '摘要',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'post_content',
    lable: '内容',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'list_order',
    lable: '排序',
    lableCol: 3,
    wrapperCol: 18,
  },


  {
    name: 'thumbnail',
    lable: '缩略图',
    lableCol: 3,
    wrapperCol: 18,
  },
];